import { useEffect } from "react";
import { hasOfflineGames } from "./registry";
import { isOfflinePlaySupported, refreshOfflineSite, registerOfflineServiceWorker, syncOfflineProgress } from "./serviceWorker";

// For users with downloaded games: keep the offline worker registered, cache
// each new site build, and sync offline progress whenever the network is back.
const useOfflineGamesLifecycle = () => {
	useEffect(() => {
		if (!isOfflinePlaySupported() || !hasOfflineGames()) return undefined;
		let cancelled = false;

		const syncAndRefresh = () => {
			if (cancelled || !navigator.onLine) return;
			syncOfflineProgress().catch((error) => console.warn("[Offline] sync failed:", error?.message));
			refreshOfflineSite().catch((error) => console.warn("[Offline] site cache refresh failed:", error?.message));
		};

		registerOfflineServiceWorker()
			.then(syncAndRefresh)
			.catch((error) => console.warn("[Offline] service worker registration failed:", error?.message));
		window.addEventListener("online", syncAndRefresh);
		return () => {
			cancelled = true;
			window.removeEventListener("online", syncAndRefresh);
		};
	}, []);
};

export default useOfflineGamesLifecycle;
